import React, { useEffect } from 'react'

import './movimento-estoque-item.scss'
import _ from 'lodash'
import { Card } from 'primereact/card'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { DataTable } from 'primereact/datatable'
import { icons } from '../../../constants'
import utils from '../../../utils'

export default function MovimentoEstoqueItem(props) {
  useEffect(() => {}, [])

  const columns = [
    {
      field: 'unidadeOrigem',
      header: utils.getMessage(props.messages, 'movimentoestoque.label.unidadeOrigem'),
      columnKey: 'unidadeOrigem',
      sortable: false,
      filter: false,
    },
    {
      field: 'unidadeDestino',
      header: utils.getMessage(props.messages, 'movimentoestoque.label.unidadeDestino'),
      columnKey: 'unidadeDestino',
      sortable: false,
      filter: false,
    },
    {
      field: 'codigo',
      header: utils.getMessage(props.messages, 'movimentoestoque.label.codigo'),
      columnKey: 'codigo',
      sortable: false,
      filter: false,
    },
    {
      field: 'descricao',
      header: utils.getMessage(props.messages, 'movimentoestoque.label.descricao'),
      columnKey: 'descricao',
      sortable: false,
      filter: false,
    },
    {
      field: 'quantidade',
      header: utils.getMessage(props.messages, 'movimentoestoque.label.quantidade'),
      columnKey: 'quantidade',
      sortable: false,
      filter: false,
    },
    {
      field: 'acoes',
      header: ' ',
      columnKey: 'acoes',
    },
  ]

  const resolveColumns = () => {
    return columns.map((col) => {
      col.showFilterMenuOptions = false
      col.showClearButton = false
      col.showFilterMenu = false

      if (col.field === 'unidadeOrigem') {
        return (
          <Column
            {...col}
            key={col.field}
            body={formatColumn}
            bodyClassName="column-descricao-body-width"
            headerClassName="column-descricao-header-width"
            filterHeaderClassName="column-descricao-filter-header-width"
          />
        )
      }
      if (col.field === 'unidadeDestino' && props.tipo === 'transferencia') {
        return (
          <Column
            {...col}
            key={col.field}
            body={formatColumn}
            bodyClassName="column-descricao-body-width"
            headerClassName="column-descricao-header-width"
            filterHeaderClassName="column-descricao-filter-header-width"
          />
        )
      }
      if (col.field === 'codigo') {
        return (
          <Column
            {...col}
            key={col.field}
            body={formatColumn}
            bodyClassName="column-codigo-body-width"
            headerClassName="column-codigo-header-width"
            filterHeaderClassName="column-codigo-filter-header-width"
          />
        )
      }
      if (col.field === 'descricao') {
        return (
          <Column
            {...col}
            key={col.field}
            body={formatColumn}
            bodyClassName="column-descricao-body-width"
            headerClassName="column-descricao-header-width"
            filterHeaderClassName="column-descricao-filter-header-width"
          />
        )
      }
      if (col.field === 'quantidade') {
        return (
          <Column
            {...col}
            key={col.field}
            body={formatColumn}
            bodyClassName="column-quantidade-body-width"
            headerClassName="column-quantidade-header-width"
            filterHeaderClassName="column-quantidade-filter-header-width"
          />
        )
      }
      if (col.field === 'acoes') {
        return (
          <Column
            {...col}
            key={col.field}
            body={actions}
            bodyClassName="column-actions-servico-body-width"
            headerClassName="column-actions-servico-header-width"
            filterHeaderClassName="column-actions-servico-filter-header-width"
          />
        )
      }
      return null
    })
  }

  const actions = (rowData) => {
    return (
      <div>
        <Button
          type="button"
          icon={icons.REMOVE_ICON}
          className="p-button-danger"
          onClick={(e) => removeItem(e, rowData)}
        />
      </div>
    )
  }

  const removeItem = (e, data) => {
    e.preventDefault()
    e.stopPropagation()
    props.onClickRemoveItem(data)
  }

  const formatColumn = (rowData, column) => {
    const field = _.get(column, 'field', '')
    if (field === 'codigo') {
      return _.get(rowData, 'produto.codigo', null)
    }
    if (field === 'descricao') {
      return _.get(rowData, 'produto.descricao', null)
    }
    if (field === 'quantidade') {
      return _.get(rowData, 'quantidade', null)
    }
    if (field === 'unidadeOrigem' || field === 'unidadeDestino') {
      return _.get(rowData[field], 'value', null)
    }
    return null
  }

  return (
    <React.Fragment>
      <Card title={utils.getMessage(props.messages, 'remessapagamento.label.itens')}>
        <div className="p-grid form-group" style={{ marginTop: '15px' }}>
          <div className="p-col-12">
            <DataTable
              emptyMessage=" "
              value={props.values}
              resizableColumns={true}
              columnResizeMode="expand"
              filterDisplay="row"
              size={'small'}
              stripedRows={true}
              responsiveLayout="scroll"
              scrollable={true}
              scrollHeight="400px"
            >
              {resolveColumns()}
            </DataTable>
          </div>
        </div>
      </Card>
    </React.Fragment>
  )
}
